/* Leia & Batce — instant cart drawer on the first add (LAB-45, 2026-09-03). Plain script, no imports.
   Horizon opens the drawer immediately only when the cart already has lines; on the first add it
   waits for /cart/add (section render) + /cart.json + the morph — 4–8 s on a phone. This script
   opens the drawer at once with an optimistic body built from the sticky bar's DOM, and lets
   Horizon's own render replace it. No MutationObserver; idempotent; never blocks the add. */
(function () {
  if (window.__lbDrawerOpen) return;
  window.__lbDrawerOpen = true;

  var EV_UPDATE = 'shopify:cart:lines-update';
  var EV_ERROR = 'shopify:cart:error';

  function drawer() { return document.getElementById('cart-drawer'); }
  function inner() { var d = drawer(); return d ? d.querySelector('.cart-drawer__inner') : null; }
  function txt(sel) { var el = document.querySelector(sel); return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function build() {
    var img = document.querySelector('.sticky-add-to-cart__image-img');
    var title = txt('.sticky-add-to-cart__title') || txt('.product-information h1') || txt('h1');
    if (!title) return null;
    var variant = txt('.sticky-add-to-cart__variant');
    var priceEl = document.querySelector('.sticky-add-to-cart__price .price-item--sale, .sticky-add-to-cart__price .price-item--regular, .sticky-add-to-cart__price');
    var price = priceEl ? (priceEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var box = document.createElement('div');
    box.className = 'lb-optimistic';
    box.setAttribute('data-lb-optimistic', '');
    var h = document.createElement('h2'); h.className = 'theme-drawer__title h4 lb-optimistic__title'; h.textContent = 'Added to your cart';
    var item = document.createElement('div'); item.className = 'lb-optimistic__item';
    if (img && img.src) { var i = document.createElement('img'); i.className = 'lb-optimistic__img'; i.alt = ''; i.src = img.src; item.appendChild(i); }
    var info = document.createElement('div');
    var n = document.createElement('div'); n.className = 'lb-optimistic__name'; n.textContent = title; info.appendChild(n);
    if (variant) { var v = document.createElement('div'); v.className = 'lb-optimistic__variant'; v.textContent = variant; info.appendChild(v); }
    if (price) { var p = document.createElement('div'); p.className = 'lb-optimistic__price'; p.textContent = price; info.appendChild(p); }
    item.appendChild(info);
    var sum = document.createElement('div'); sum.className = 'lb-optimistic__summary';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'button lb-optimistic__cta'; b.disabled = true;
    var bt = document.createElement('span'); bt.className = 'button-text'; bt.textContent = 'Adding…'; b.appendChild(bt);
    var note = document.createElement('p'); note.className = 'lb-notes'; note.textContent = 'Usually arrives in 6–12 days, with tracking by email.';
    sum.appendChild(b); sum.appendChild(note);
    box.appendChild(h); box.appendChild(item); box.appendChild(sum);
    return box;
  }

  /* Non-empty cart: Horizon opens the drawer at once, but the new line only appears after
     /cart/add + /cart.json + the morph. Show the line immediately at the top of the items list;
     the morph removes it when the real row arrives. */
  function buildRow() {
    var img = document.querySelector('.sticky-add-to-cart__image-img');
    var title = txt('.sticky-add-to-cart__title') || txt('.product-information h1') || txt('h1');
    if (!title) return null;
    var variant = txt('.sticky-add-to-cart__variant');
    var priceEl = document.querySelector('.sticky-add-to-cart__price .price-item--sale, .sticky-add-to-cart__price .price-item--regular, .sticky-add-to-cart__price');
    var price = priceEl ? (priceEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var row = document.createElement('div');
    row.className = 'lb-optimistic__item lb-optimistic__row';
    row.setAttribute('data-lb-optimistic', '');
    if (img && img.src) { var i = document.createElement('img'); i.className = 'lb-optimistic__img'; i.alt = ''; i.src = img.src; row.appendChild(i); }
    var info = document.createElement('div');
    var n = document.createElement('div'); n.className = 'lb-optimistic__name'; n.textContent = title; info.appendChild(n);
    if (variant) { var v = document.createElement('div'); v.className = 'lb-optimistic__variant'; v.textContent = variant; info.appendChild(v); }
    var st = document.createElement('div'); st.className = 'lb-optimistic__variant'; st.textContent = (price ? price + ' · ' : '') + 'Adding…'; info.appendChild(st);
    row.appendChild(info);
    return row;
  }
  function bumpBadge(qty) {
    var d = drawer(); var b = d && d.querySelector('.theme-drawer__badge');
    if (!b) return;
    var n = parseInt((b.textContent || '').trim(), 10);
    if (!isNaN(n)) { b.textContent = String(n + qty); b.classList.remove('visually-hidden'); }
  }
  function quantityOf(target) {
    var form = target instanceof Element ? target.closest('product-form-component') : null;
    var q = form && form.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function refocus() {
    var d = drawer(); if (!d || d.contains(document.activeElement)) return;
    var c = d.querySelector('.theme-drawer__close-button');
    if (c) { try { c.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  }
  /* Horizon decides whether the summary stays sticky (cart-summary-sticky) when the drawer opens.
     With the optimistic body there is no summary yet, so it records "false" and its later recompute
     can land before the morph. Once the real summary exists, apply the same rule Horizon uses
     (summary taller than half the dialog -> not sticky). */
  function settle() {
    var d = drawer(); if (!d) return false;
    var dlg = d.querySelector('dialog'), sum = d.querySelector('.cart-drawer__summary'), content = d.querySelector('.cart-drawer__content');
    if (!dlg || !sum || !content || d.querySelector('[data-lb-optimistic]')) return false;
    var ratio = sum.getBoundingClientRect().height / Math.max(dlg.getBoundingClientRect().height, 1);
    dlg.setAttribute('cart-summary-sticky', ratio > 0.5 ? 'false' : 'true');
    return true;
  }
  function settleSoon() {
    var tries = 0;
    var t = setInterval(function () { if (settle() || ++tries > 24) clearInterval(t); }, 250);
  }
  function clear() {
    var i = inner(); if (!i) return;
    var n = i.querySelector('[data-lb-optimistic]'); if (n) n.remove();
    i.classList.remove('lb-optimistic');
    refocus();
    settleSoon();
  }
  function fail() {
    clear();
    var d = drawer();
    if (d && d.hasAttribute('open') && typeof d.close === 'function') { try { d.close(); } catch (e) { /* ignore */ } }
  }

  document.addEventListener(EV_UPDATE, function (event) {
    try {
      if (!event || event.action !== 'add') return;
      var d = drawer(), i = inner();
      if (!d || !i || typeof d.open !== 'function') return;
      if (!d.querySelector('cart-drawer-component[auto-open]')) return;   // auto-open is off: leave it
      var t = event.target;
      if (t instanceof Element && t.closest('dialog:modal')) return;       // quick-add modal: Horizon sequences it
      if (i.querySelector('[data-lb-optimistic]')) return;
      if (!i.classList.contains('cart-drawer--empty')) {
        // non-empty cart: Horizon's listener runs before this one and has already opened the drawer;
        // we only put the new line in view now (an "already open" guard here would skip it)
        var list = i.querySelector('.cart-drawer__items');
        var row = list ? buildRow() : null;
        if (!row) return;
        list.insertBefore(row, list.firstChild);
        bumpBadge(quantityOf(t));
        if (event.promise && typeof event.promise.then === 'function') {
          event.promise.then(function () { setTimeout(clear, 2500); }, function () { clear(); });
        } else { setTimeout(clear, 4000); }
        return;
      }
      if (d.hasAttribute('open')) return;                                  // empty cart, already open: nothing to do
      var box = build(); if (!box) return;
      i.appendChild(box);
      i.classList.add('lb-optimistic');
      d.open();
      var guard = setTimeout(function () { var x = inner(); if (x && x.classList.contains('cart-drawer--empty')) fail(); }, 10000);
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(function (r) {
          clearTimeout(guard);
          if (r && r.detail && r.detail.didError) { fail(); } else { settleSoon(); setTimeout(clear, 2500); }   // the morph removes it; clear() is the safety net
        }, function () { clearTimeout(guard); fail(); });
      }
    } catch (e) { /* never break the add */ }
  });
  document.addEventListener(EV_ERROR, function () {
    var i = inner(); if (i && i.classList.contains('lb-optimistic')) fail();
  });
})();
